/** Shared objective sequences for client submit + server verification. */
export const LEVEL_OBJECTIVE_SEQUENCES: Record<string, string[]> = {
  'mic-01-chai-drill': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-02-barricade-bazaar': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-03-news-van-crossing': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-04-confiscation-lane': ['find-mic', 'carry-mic', 'escape', 'completed'],
  'mic-05-barricade-captain': ['boss-fight', 'escape', 'completed'],
  'mic-06-gas-gali': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-07-wire-tangle': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-08-stage-power': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-09-metro-approach': ['find-mic', 'power-stage', 'escape', 'completed'],
  'mic-10-detention-superintendent': ['boss-fight', 'escape', 'completed'],
  'paper-01-printing-lane': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-02-stamp-market': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-03-gas-ledger': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-04-basement-bundles': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-05-packet-auditor': ['boss-fight', 'escape', 'completed'],
  'paper-06-carbon-copy': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-07-wire-room': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-08-gas-stampede': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-09-archive-approach': ['find-mic', 'power-stage', 'escape', 'completed'],
  'paper-10-verification-chief': ['boss-fight', 'escape', 'completed'],
};

export const MISSION1_LEVEL_IDS = Object.keys(LEVEL_OBJECTIVE_SEQUENCES).filter((id) => id.startsWith('mic-'));
export const MISSION2_LEVEL_IDS = Object.keys(LEVEL_OBJECTIVE_SEQUENCES).filter((id) => id.startsWith('paper-'));
export const PLAYABLE_LEVEL_IDS = Object.keys(LEVEL_OBJECTIVE_SEQUENCES);
export const MISSION1_OBJECTIVE_SEQUENCES = LEVEL_OBJECTIVE_SEQUENCES;

export const CURRENT_CONTENT_VERSION = 4;
